import React, { lazy } from 'react';
import { PageBanner } from '../components/PageBanner';
import { motion } from 'framer-motion';
import { CalendarIcon } from 'lucide-react';
export function BookingPage() {
  return <>
      <PageBanner title="Book Appointment" subtitle="Schedule your fingerprinting appointment online in just a few clicks." data-id="element-298" />

      <section className="py-16 bg-white" data-id="element-299">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-300">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} data-id="element-301">
            {/* Booking Info */}
            <div className="text-center mb-10" data-id="element-302">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#F0F4FF] rounded-full border border-[#E7ECF8] mb-4" data-id="element-303">
                <CalendarIcon className="h-4 w-4 text-[#4AA6CF]" data-id="element-304" />
                <span className="text-sm font-medium text-[#1E1F55]" data-id="element-305">
                  Online Scheduling
                </span>
              </div>
              <p className="text-gray-600 max-w-xl mx-auto leading-relaxed" data-id="element-306">
                Select your preferred service, date, and time below.
                Appointments are scheduled every 15 minutes.
              </p>
            </div>

            {/* Zoho Bookings Iframe */}
            <div className="rounded-2xl border border-gray-200 overflow-hidden shadow-sm bg-gray-50" data-id="element-307">
              <iframe src="https://ambientfingerprintingsolutions.zohobookings.com/portal-embed#/4623993000000036016" width="100%" height="700" title="Book an Appointment - Ambient Fingerprinting" style={{
              border: 0,
              display: 'block',
              minHeight: '600px'
            }} loading="lazy" allowFullScreen data-id="element-308"></iframe>
            </div>

            {/* Help Text */}
            <p className="text-center text-sm text-gray-500 mt-6" data-id="element-309">
              Having trouble booking? Call us directly at{' '}
              <a href="tel:4105255285" className="text-[#4AA6CF] font-medium hover:underline" data-id="element-310">
                410-525-5285
              </a>
            </p>
          </motion.div>
        </div>
      </section>
    </>;
}